export function exportCsvWithDate(baseName, headers, rows) {
  const date = new Date().toISOString().slice(0,10);
  const filename = `${baseName}-${date}.csv`;
  exportCsv(filename, headers, rows);
}

export function exportCsv(filename, headers, rows) {
  // headers: array of strings
  // rows: array of objects (matching header keys) or array of arrays
  const csvRows = [];
  if (Array.isArray(headers)) {
    csvRows.push(headers.join(','));
  }

  if (rows.length > 0) {
    if (Array.isArray(rows[0])) {
      rows.forEach(r => {
        csvRows.push(r.map(cell => escapeCell(cell)).join(','));
      });
    } else {
      // assume objects
      rows.forEach(r => {
        const line = headers.map(h => escapeCell(r[h] === undefined || r[h] === null ? '' : r[h]));
        csvRows.push(line.join(','));
      });
    }
  }

  const blob = new Blob([csvRows.join('\n')], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  link.setAttribute('href', url);
  link.setAttribute('download', filename);
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}

function escapeCell(cell) {
  const s = String(cell).replace(/"/g, '""');
  if (s.indexOf(',') >= 0 || s.indexOf('\n') >= 0 || s.indexOf('"') >= 0) {
    return `"${s}"`;
  }
  return s;
}
